<template>
  <div class="popup points">
    <div class="popup__container">
      <PointsHeader @closePopup="closePopup" />
      <div class="popup__content">
        <h4>{{ $t("points.header_text") }}</h4>
        <div class="popup__list">
          <PointsItem
            v-for="(offer, offer_index) in getPointOffers"
            :key="offer.service_id"
            :offer="offer"
            :activeIndex="active_index"
            :offerIndex="offer_index"
            :currency="currency"
            @setActiveOffer="setActiveOffer"
          />
        </div>
        <Warning class="popup__warning" :warningText="$t('points.bottom_warning')" />
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/points/styles/points.styl";
import BillingService from "@libs/billing/wf/BillingService";
import PointsItem from "./blocks/PointsItem";
import PointsHeader from "./blocks/PointsHeader";
import Warning from "@/components/Common/Warning";
import ThrowGTMEvent from "@model/helpers/ThrowGTMEvent";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Points",
  components: {
    PointsItem,
    PointsHeader,
    Warning,
  },
  data() {
    return {
      points: [100, 500, 2500],
      active_index: 1,
    };
  },
  computed: {
    ...mapState("billing", ["currency", "getPaymentFrameData"]),
    ...mapGetters("billing", ["getPointOffers"]),
    activeOffer() {
      return this.getPointOffers[this.active_index];
    },
  },
  created() {
    BillingService.initBilling();
  },
  methods: {
    setActiveOffer(offer_index) {
      this.active_index = offer_index;
      this.handlerForBilling();
    },
    handlerForBilling() {
      ThrowGTMEvent("ch.buy_points", { points_type: this.activeOffer.name });
      BillingService.createInvoice(this.activeOffer.service_id);
    },
    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>
